import { appendTicketMessage } from './technicalTickets';

const currencyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
});

function money(value) {
  const num = Number(value);
  return currencyFormatter.format(Number.isFinite(num) ? num : 0);
}

function formatDate(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('it-IT');
}

function normalizeType(type) {
  return type === 'subtract' || type === 'scala' ? 'subtract' : 'add';
}

export function buildCreditMovementTicketMessage({
  movement = {},
  total = 0,
  userName = '',
} = {}) {
  const type = normalizeType(movement.type || movement.tipo);
  const amount = Number(movement.amount ?? movement.valore) || 0;
  const date = movement.date || movement.data || '';
  const expiryDate = movement.expiryDate || movement.dataScadenza || '';
  const greeting = userName ? `Ciao ${userName},` : 'Ciao,';
  const verb = type === 'subtract' ? 'scaricato' : 'aggiunto';
  const lines = [
    greeting,
    `ti informiamo che è stato ${verb} un movimento sul tuo credito Fusco Fit.`,
    `Importo: ${money(amount)}.`,
    `Credito residuo: ${money(total)}.`,
  ];

  const dateLabel = formatDate(date);
  if (dateLabel) {
    lines.push(`Data movimento: ${dateLabel}.`);
  }

  const expiryLabel = type === 'add' ? formatDate(expiryDate) : '';
  if (expiryLabel) {
    lines.push(`Scadenza credito: ${expiryLabel}.`);
  }

  lines.push(
    'Per utilizzare questo credito, puoi scriverci qui in questa chat oppure puoi scrivere a team@fusco.fit.'
  );
  lines.push(
    'I nostri consulenti ti aiuteranno a sfruttare al meglio questo credito.'
  );

  return lines.join('\n\n');
}

export async function notifyCreditMovement({
  db,
  userUid,
  movement,
  total,
  userName = '',
  preserveOpenStatus = true,
  notifyUser = true,
  awaitNotification = false,
} = {}) {
  if (!db || !userUid || !movement) return null;
  const type = normalizeType(movement.type || movement.tipo);
  const amount = Number(movement.amount ?? movement.valore) || 0;
  const message = buildCreditMovementTicketMessage({ movement, total, userName });
  const triggeredAt = new Date().toISOString();
  const movementId = movement.id || `credit-${Date.now()}`;

  return appendTicketMessage({
    db,
    userUid,
    message,
    title: type === 'subtract' ? 'Credito utilizzato' : 'Credito aggiunto',
    ticketId: `credit-${movementId}`,
    ticketExtra: {
      tipoTicket: 'Tecnico',
      source: 'user-credit-movement',
      creditMovementId: movementId,
      creditMovementType: type,
      creditAmount: amount,
      creditTotal: Number(total) || 0,
      creditDate: movement.date || movement.data || null,
      creditExpiryDate: movement.expiryDate || movement.dataScadenza || null,
      triggeredAt,
    },
    conversationExtra: {
      source: 'user-credit-movement',
      creditMovementId: movementId,
      creditMovementType: type,
      creditAmount: amount,
      creditTotal: Number(total) || 0,
      triggeredAt,
    },
    preserveOpenStatus,
    notifyUser,
    awaitNotification,
  });
}
